import { t } from "i18next"
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap"
import { ExamCertificate } from "../Exam/ExamCertificate"


export const CertificateModal = ({ isOpen, onClose, employeeExam }) => {
    return (
        <Modal isOpen={isOpen} toggle={onClose} size={'xl'}>
            {/* <ModalHeader toggle={onClose}>
                {questionary.name} <small>(<small>v</small>{questionary.version}.0)</small>
            </ModalHeader> */}
            <ModalBody>
                <ExamCertificate
                    {...employeeExam}
                    isEmployee
                />
            </ModalBody>
            <ModalFooter>
                <Button onClick={onClose}>{t('common.close')}</Button>
            </ModalFooter>
        </Modal >

    )
}
